export const nodeContainsDescendant = (rootNode, descendant) => {
    if (rootNode === descendant) {
        return true;
    }
    let parent = descendant.parentNode;
    while (parent != null) {
        if (parent === rootNode) {
            return true;
        }
        parent = parent.parentNode;
    }
    return false;
};
export const wasContentNodeDescendant = (composedPath, contentNode) => contentNode.current != null && composedPath.includes(contentNode.current);
//# sourceMappingURL=descendant.js.map